import { horizontal } from "../options/horizontal";
import { vertical } from "../options/vertical";
import getEmphasis from "./get-emphasis";
import { lengthDataHandler } from "./get-length";
import { groupArrays } from "./group-arrays";

type TProps = {
  primaryColor?: string;
  colors: string[];
  type: "horizontal" | "vertical";
  data: Record<string, string>[][];
  payload: Record<string, unknown>;
};

export const barData = ({
  data,
  colors,
  primaryColor,
  type,
  payload,
}: TProps) => {
  const [seriesTitles, ...restData] = data;
  seriesTitles.shift();
  const grouped = groupArrays(
    restData.map((row) => row.filter((cell) => !!cell?.value)),
  );
  let [axisTitles = [], ...gropedData] = grouped;
  const titles = axisTitles.map((cell) => cell?.value ?? "");

  if (type === "horizontal") {
    titles.reverse();
    gropedData = gropedData.map((arr) => arr.reverse());

    if (gropedData.length === 1) {
      colors = colors.splice(0, gropedData[0].length);
      if (colors.length < gropedData[0].length) {
        colors = colors.concat(
          Array(gropedData[0].length - colors.length).fill(primaryColor),
        );
      }
      colors.reverse();
    }
  }

  let series = gropedData.map((arr, i) => {
    const mapped = arr.map((cell) => cell?.value ?? 0);
    const seriesColor = colors[i] ?? primaryColor;
    return {
      data: mapped,
      type: "bar",
      itemStyle: { color: seriesColor },
      name: seriesTitles[i]?.value ?? "",
      // universalTransition: true,
      animationDurationUpdate: 1000,
      emphasis: getEmphasis(seriesColor),
    };
  });

  if (series.length === 1) {
    const seriesData = series[0].data.map((value, index) => {
      const itemColor = colors[index] ?? primaryColor;
      return {
        value,
        itemStyle: { color: itemColor },
        emphasis: getEmphasis(itemColor),
      };
    });

    series = [
      {
        data: seriesData,
        type: "bar",
        name: seriesTitles[0]?.value ?? "",
        // universalTransition: true,
        animationDurationUpdate: 1000,
      },
    ] as any[];
  }

  return {
    option:
      type === "horizontal"
        ? horizontal(payload, { titles, series })
        : vertical(payload, { titles, series }),
    ...lengthDataHandler(titles, series),
  };
};
